// tslint:disable
import { Log } from 'ng2-logger';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Common } from '../../core/common';
import Translator from '../../core/i18n';
import { ReportService } from '../../api/report-services';
import RolesModal from '../../components/popup/roles-modal';
import Switch from 'react-switch';

const T = Translator.create();
const _logger = Log.create('Reports Page');
let _common: Common;
const _reportService = new ReportService();

class RolesPage extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        _common = new Common();
        this.state={
            existRole: true,
            filterModalOpen: false,
            editRole: false,
            activitySettings: true,
            questionBankProcess: true,
            helpProcess: true,
            announcementProcess: true,
            createAnnouncement: true,
            deleteAnnouncement: true,
            emailAnnouncement: true

        }

    }

    triggerRoleModal = () => {

        let filterModalOpenStatus = false;
        if (!this.state.filterModalOpen)
        {
            filterModalOpenStatus = true;
        }

        this.setState({
            filterModalOpen: filterModalOpenStatus
        });
    };



    editRole = () => 
    {
        this.setState({editRole: true});
    }

    switchEdit = (param: any, value: boolean) => 
    {

        let activitySettingsValue = this.state.activitySettings;
        let questionBankProcessValue = this.state.questionBankProcess;
        let helpProcessValue = this.state.helpProcess;
        let announcementProcessValue = this.state.announcementProcess;
        let createAnnouncementValue = this.state.createAnnouncement;
        let deleteAnnouncementValue = this.state.deleteAnnouncement;
        let emailAnnouncementValue = this.state.emailAnnouncement;

        if (param == "activitySettings")
        {
            activitySettingsValue = value;
        }
        else if (param == "questionBank")
        {
            questionBankProcessValue = value;
        } 
        else if (param == "help")
        {
            helpProcessValue = value;
        }
        else if (param == "announcement")
        {
            announcementProcessValue = value;
        }
        else if (param == "createAnnouncement")
        {
            createAnnouncementValue = value;
        }
        else if (param == "deleteAnnouncement")
        {
            deleteAnnouncementValue = value;
        }
        else if (param == "emailAnnouncement")
        {
            emailAnnouncementValue = value;
        }

        this.setState((prevState: any) => (
            {activitySettings: activitySettingsValue, questionBankProcess: questionBankProcessValue, helpProcess: helpProcessValue, 
            announcementProcess: announcementProcessValue,
            createAnnouncement: createAnnouncementValue,
            deleteAnnouncement: deleteAnnouncementValue,
            emailAnnouncement: emailAnnouncementValue,

        }))
    }

    viewArrow = (param: boolean) =>
    {
        if(param)
        {
            return "keyboard_arrow_down"
        }
        else
        {
            return "keyboard_arrow_up"

        }

    }

    render() {
       
        return (
            <div className="student-course  activities-dashboard">
                <div className="container">
                <div  className="row student-course-header question-filter pt-0 pb-3">
                <div className="col-md-6">
                <div className="d-flex justify-content-between">
                                <div>
                                    <h2>{T.t('r_system_roles')}</h2>
                                </div>
                            </div>
                 </div>

                 <div className="col-md-6">
                                <div className='text-md-right'>
                                <button className="ml-2 category-tag-square tag-green" onMouseDown={this.triggerRoleModal}>+ {T.t('r_system_roles_new')}</button>
                                </div>
                     
                 </div>

                 {this.state.filterModalOpen && (
                <RolesModal
                isProjectSubActivity={this.props!}
                modalIsOpen={true} 
                onClose={this.triggerRoleModal}
                />
                )}

                </div>

                <div style={{ paddingTop: 0, paddingBottom: 10 }} className="row student-course-header question-filter">
                <div className="col-md-6">
                    {(!this.state.existRole) ?
                    (   
                    <div >
                        <div className='text-center pt-5'>
                        <img src={require('./system_role.svg')} className='img-responsive center-block pb-2' />
                        <br/><b>{T.t('r_system_roles_no_role')}</b>
                        <div className='small pt-1'>{T.t('r_system_roles_no_role_info')}</div>
                        </div>
                    </div>
                    )
                    :
                    (
                        <div className='col-md-12 ml-2'>
                            <div className='row p-0 m-0'>
                                <div className='col-md-10 p-0 m-0' style={{borderBottom: "1px solid black"}}>Yönetici</div>
                                <div className='col-md-2 p-0 m-0'></div>
                            </div>
                            <div className='row pt-3 ml-4'>
                                <div className='col-md-12 p-0 m-0' >
                                <div className='row'>
                                <div className='col-md-9 p-0 m-0 role-div' onMouseDown={this.editRole}>
                                    <div className='row'>
                                    <div className='col-md-10'>XYZ Yönetici</div>
                                    <div className='col-md-2 role-div-notification'>2</div>
                                        </div>
                                    </div>
                                <div className='col-md-3 p-0 m-0 pt-1'>
                                 
                                 <div className='ml-5 role-div-dots' style={{display: "inline-block"}} data-toggle="dropdown" >
                                  <img src="/dots.svg" className="m-t-15" alt="Dots" />
                                  </div>  

                                  
                                  <div
                        className="dropdown-menu shadow"
                        aria-labelledby="dropdownMenuButton"
                        style={{
                            position: 'absolute',
                            transform: ' translate3d(-165px, 22px, 0px); top: 0px; left: 0px; will-change: transform'
                        }}
                    >
                    
                       
                    <a className={`dropdown-item`} onMouseDown={this.triggerRoleModal}>{T.t('r_gen_edit')}</a>
                    <a className={`dropdown-item`} >{T.t('r_system_roles_view_users')}</a>
                    <a className={`dropdown-item`} >{T.t('r_system_roles_create_copy')}</a>
                    <div className="dropdown-divider" />
                                <p
                                    className="dropdown-item text-danger mb-1"
                                    style={{ cursor: 'pointer', paddingTop: 4 + 'px !important' }}
                                >
                                    {T.t('r_system_roles_delete_role')}
                                </p>
                     
                   
                    </div>



                                </div>
                                </div>
                                </div>
                                
                            </div>
                        </div>
                    )
                    
                    }
             
                 </div>

                 <div className="col-md-6">
                        {(!this.state.editRole) ?
                        (
                                <div className='text-md-left'>
                                <b><i className='material-icons'>info</i> {T.t('r_system_roles_info')}</b>
                                <br/>
                                Eğitim365’de sistem rolleri, farklı kullanıcıların platform üzerindeki görevlerini ve yetkilerini düzenlemek için kullanılır. Her bir rolle ilişkilendirilen kullanıcılar, rolün içerdiği tüm yetkilere sahip olurlar.<br/><br/>
Platformda yer alan temel (varsayılan) sistem rolleri şunlardır:<br/><br/>
     <b>1-Yönetici (Admin):</b> Platformun en üst düzeydeki yetkilisidir. Yönetici, sistemin tüm yönlerini kontrol edebilir, kullanıcı hesaplarını yönetebilir, içerikleri oluşturabilir ve düzenleyebilir, raporları görüntüleyebilir ve genel sistem ayarlarını yapabilir.<br/><br/>
     <b>2-Eğitmen (Instructor):</b> Öğrencilere içerik sunan ve dersleri yöneten kullanıcılardır. Ders altında içerik oluşturabilir, sınıfları yönetebilir, ödevler verebilir ve değerlendirmeler yapabilir.<br/><br/>
     <b>3-Öğrenci (Student):</b> Platforma kayıtlı olan öğrencilere atfedilir. Öğrenciler, ders içeriklerini görüntüleyebilir, ödevleri tamamlayabilir, sınavlara girebilir ve eğitmenlerle iletişim kurabilir.<br/><br/>
     <b>4-Program Yöneticisi (Program Admin):</b> Yetkilendirildiği programlar üzerinde üst düzey rol özelliklerine sahiptir. Programlara bağlı olan dersleri ve kullanıcıları görebilir ve yönetebilir, programlara bağlı kullanıcılar ile iletişime geçebilir, içerikleri oluşturabilir ve düzenleyebilir, programlar genelinde raporlama yapabilir. <br/><br/>
Eğitm365 platformunda varsayılan 4 temel rol üzerinden yeni roller tanımlayabilirsiniz. Yeni bir rol tanımlandığında rolün yetkileri seçilen temel rol ile aynı olacaktır. Tanımlanan rol için temel rolün kullanabildiği yetkilendirmeleri düzenleyerek kaydedebilirsiniz. Böylece her rol için hangi işlevlere erişim yetkisi olduğunu tanımlayabilirsiniz. 

                                <br/><br/>
                                <b><i className='material-icons'>info</i> {T.t('r_system_roles_unit_info')}</b><br/><br/>
                                Eğitim365'te kullanıcıları Birim(Program) bazında yetkilendirmeniz mümkün. Kullanıcı, belirli bir programa özel olarak yetkilendirildiğinde, ilgili programa ve işlemlere özgü rol yetkilerini kullanabilir. Birim yetkilendirmesinde belirlenen rol sadece seçilen program için geçerli olacaktır. Kullanıcının sistem genelindeki diğer programlar ve işlevler üzerindeki yetkisi, kullanıcı oluşturma/düzenleme aşamasında seçilen role bağlı olacaktır.<br/><br/>
Kullanıcının programa özgü yetkilendirmesi aşağıdaki şekillerde yapılabilir:<br/><br/>
<b>1- Program Yöneticisi:</b> Kullanıcı, Program Yöneticisi olarak atanırsa, Eğitmen veya Öğrenci gibi temel rollerine ek olarak seçilen programda yönetici yetkileri kazanır. Bu sayede diğer sistem işlemlerinde ve bağlı ders işlemlerinde temel rolünün yetkilerini kullanabilir.<br/><br/>
<b>2- Program Kullanıcısı:</b> Kullanıcı, Program Kullanıcısı olarak atanırsa, temel rolünün yetkilerini korur. Bu yöntemle kullanıcının seçilen programın yöneticisi tarafından görülebilmesi ve yönetilebilmesi sağlanır.<br/><br/>
<b>3- Program Yöneticisi Üzerinden Oluşturulan Yeni Roller:</b> Platformda yeni roller oluşturulurken temel rol olarak Program Yöneticisi seçilirse, bu roller, kullanıcıya program yetkilendirmesi aşamasında gösterilir. Bu sayede kullanıcı, seçilen programla ilgili tanımlanan yetkileri kullanabilir. Kullanıcının sistem genelindeki diğer programlar ve işlevler üzerindeki yetkisi, kullanıcı oluşturma/düzenleme aşamasında seçilen role bağlı olacaktır.

                                </div>
                        ) : 
                                
                        (
                        <div className='row'>

  <div className='my-4 header-scroll col-12 p-2' style={{border: "1px solid #00000042", cursor: "pointer", backgroundColor: "white" }}>

<div className='row'>
<div className='col-9'> 
<div className='row'>
<div className='col-2 text-center'>
 <Switch
                            id={'activitySettings'}
                            name={'activitySettings'}
                            onChange={(e: any) => this.switchEdit('activitySettings', e)}
                            checked={this.state.activitySettings}
                            onColor="#86d3ff"
                            onHandleColor="#28a745"
                            handleDiameter={30}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                            height={20}
                            width={48}
                            className="react-switch"
                        /> </div>
                        <div className='col-10'>
                        {T.t('r_system_roles_activity_process')}</div>
                        </div>
                        </div>
<div className='col-3 pr-2'>
    <button className="material-icons pr-1 pl-1 mb-1 float-right" data-event="14" style={{border : "none", background: "none"}}>{this.viewArrow(true)}</button></div>
</div>
   </div>

   <div className='header-scroll col-12 p-2 mb-4' style={{border: "1px solid #00000042", cursor: "pointer", backgroundColor: "white" }}>

<div className='row'>
<div className='col-9'> 
<div className='row'>
<div className='col-2 text-center'>
 <Switch
                            id={'announcement'}
                            name={'announcement'}
                            onChange={(e: any) => this.switchEdit('announcement', e)}
                            checked={this.state.announcementProcess}
                            onColor="#86d3ff"
                            onHandleColor="#28a745"
                            handleDiameter={30}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                            height={20}
                            width={48}
                            className="react-switch"
                        /> </div>
                        <div className='col-10'>
                        {T.t('r_system_roles_announcement_process')}</div>
                        </div>
                        </div>
<div className='col-3 pr-2'>
    <button className="material-icons pr-1 pl-1 mb-1 float-right" data-event="14" style={{border : "none", background: "none"}}>{this.viewArrow(this.state.announcementProcess)}</button>
    </div>
</div>

{(this.state.announcementProcess) &&
                        (
                            <div>
                                <div className='row ml-2 mt-2'><div className='col-12'> 
                                <div className='row'>
                                <div className='col-2 text-center'>
                                <Switch
                                                            id={'createAnnouncement'}
                                                            name={'createAnnouncement'}
                                                            onChange={(e: any) => this.switchEdit('createAnnouncement', e)}
                                                            checked={this.state.createAnnouncement}
                                                            onColor="#86d3ff"
                                                            onHandleColor="#28a745"
                                                            handleDiameter={30}
                                                            uncheckedIcon={false}
                                                            checkedIcon={false}
                                                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                                            height={20}
                                                            width={48}
                                                            className="react-switch"
                                                        /> </div>
                                                        <div className='col-10'>
                                                        {T.t('r_system_roles_create_announcement')}</div>
                                                        </div>
                                                        </div>
                                </div>

                                <div className='row ml-2 mt-2'><div className='col-12'> 
                                <div className='row'>
                                <div className='col-2 text-center'>
                                <Switch
                                                            id={'deleteAnnouncement'}
                                                            name={'deleteAnnouncement'}
                                                            onChange={(e: any) => this.switchEdit('deleteAnnouncement', e)}
                                                            checked={this.state.deleteAnnouncement}
                                                            onColor="#86d3ff"
                                                            onHandleColor="#28a745"
                                                            handleDiameter={30}
                                                            uncheckedIcon={false}
                                                            checkedIcon={false}
                                                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                                            height={20}
                                                            width={48}
                                                            className="react-switch"
                                                        /> </div>
                                                        <div className='col-10'>
                                                        {T.t('r_system_roles_delete_announcement')}</div>
                                                        </div>
                                                        </div>
                                </div>

                                <div className='row ml-2 mt-2'><div className='col-12'> 
                                <div className='row'>
                                <div className='col-2 text-center'>
                                <Switch
                                                            id={'emailAnnouncement'}
                                                            name={'emailAnnouncement'}
                                                            onChange={(e: any) => this.switchEdit('emailAnnouncement', e)}
                                                            checked={this.state.emailAnnouncement}
                                                            onColor="#86d3ff"
                                                            onHandleColor="#28a745"
                                                            handleDiameter={30}
                                                            uncheckedIcon={false}
                                                            checkedIcon={false}
                                                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                                            height={20}
                                                            width={48}
                                                            className="react-switch"
                                                        /> </div>
                                                        <div className='col-10'>
                                                        {T.t('r_system_roles_send_announcement_email')}</div>
                                                        </div>
                                                        </div>
                                </div>
                            </div>
                        )
                        }
   </div>

   <div className='header-scroll col-12 p-2' style={{border: "1px solid #00000042", cursor: "pointer", backgroundColor: "white" }}>

<div className='row'>
<div className='col-9'> 
<div className='row'>
<div className='col-2 text-center'>
 <Switch
                            id={'questionBank'}
                            name={'questionBank'}
                            onChange={(e: any) => this.switchEdit('questionBank', e)}
                            checked={this.state.questionBankProcess}
                            onColor="#86d3ff"
                            onHandleColor="#28a745"
                            handleDiameter={30}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                            height={20}
                            width={48}
                            className="react-switch"
                        /> </div>
                        <div className='col-10'>
                        {T.t('r_system_roles_question_bank_process')}</div>
                        </div>
                        </div>
<div className='col-3 pr-2'>
    <button className="material-icons pr-1 pl-1 mb-1 float-right" data-event="14" style={{border : "none", background: "none"}}>{this.viewArrow(true)}</button></div>
</div>
   </div>


   <div className='header-scroll col-12 p-2 mt-4' style={{border: "1px solid #00000042", cursor: "pointer", backgroundColor: "white" }}>

<div className='row'>
<div className='col-9'> 
<div className='row'>
<div className='col-2 text-center'>
 <Switch
                            id={'help'}
                            name={'help'}
                            onChange={(e: any) => this.switchEdit('help', e)}
                            checked={this.state.helpProcess}
                            onColor="#86d3ff"
                            onHandleColor="#28a745"
                            handleDiameter={30}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                            height={20}
                            width={48}
                            className="react-switch"
                        /> </div>
                        <div className='col-10'>
                        {T.t('r_system_roles_help_request_process')}</div>
                        </div>
                        </div>
<div className='col-3 pr-2'>
    <button className="material-icons pr-1 pl-1 mb-1 float-right" data-event="14" style={{border : "none", background: "none"}}>{this.viewArrow(true)}</button></div>
</div>
   </div>
                        </div>
                       )}
                     
                 </div>
            
                </div>

                </div>
            </div>
        );
    }
}

export default withRouter(RolesPage);
